import axios from 'axios';

import { axiosHeaderV2, getV2RootUrl } from 'common/helpers/apiHelper';
import { customerId } from 'common/helpers/tokenHelper';

export const listPastPurchases = () =>
  axios.get(
    `${getV2RootUrl()}/customer/${customerId()}/purchased-product?availableOnly=true`,
    axiosHeaderV2()
  );
